var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMarketingInputBrief(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62,70.75a.7502.7502,0,0,0,.75-.75V24a.75027.75027,0,0,0-.21973-.53027l-14-14A.74942.74942,0,0,0,48,9.25H18a.7502.7502,0,0,0-.75.75V70a.7502.7502,0,0,0,.75.75ZM48.75,11.81055,60.18945,23.25H48.75ZM18.75,10.75h28.5V24a.7502.7502,0,0,0,.75.75H61.25v44.5H18.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.75,38.56885v-1.4917a.75.75,0,0,0-1.5,0v1.4917a.75.75,0,0,0,1.5,0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28,39.31885a.7502.7502,0,0,0,.75-.75V35.09863a.75.75,0,0,0-1.5,0v3.47022A.7502.7502,0,0,0,28,39.31885Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32,40.75a.7502.7502,0,0,0,.75-.75V32.34473a.75.75,0,0,0-1.5,0V40A.7502.7502,0,0,0,32,40.75Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36,39.31885a.7502.7502,0,0,0,.75-.75V35.09863a.75.75,0,0,0-1.5,0v3.47022A.7502.7502,0,0,0,36,39.31885Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40,39.31885a.7502.7502,0,0,0,.75-.75V37.08154a.75.75,0,1,0-1.5,0v1.48731A.7502.7502,0,0,0,40,39.31885Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M44,39.31885a.7502.7502,0,0,0,.75-.75V35.09863a.75.75,0,0,0-1.5,0v3.47022A.7502.7502,0,0,0,44,39.31885Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48,40.75a.7502.7502,0,0,0,.75-.75V32.34473a.75.75,0,0,0-1.5,0V40A.7502.7502,0,0,0,48,40.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52,39.31885a.7502.7502,0,0,0,.75-.75V35.09863a.75.75,0,0,0-1.5,0v3.47022A.7502.7502,0,0,0,52,39.31885Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56,36.32715a.7502.7502,0,0,0-.75.75v1.4917a.75.75,0,0,0,1.5,0v-1.4917A.7502.7502,0,0,0,56,36.32715Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 47.25,
    width: 32,
    height: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 53.25,
    width: 22,
    height: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMarketingInputBrief);
export default __webpack_public_path__ + "static/media/icon_marketing_input_brief.48107fd7091a64d733e9bbda3c97410c.svg";
export { ForwardRef as ReactComponent };